// extracted by mini-css-extract-plugin
export default {"small":"12px","medium":"14px","large":"16px","extraLarge":"30px"};